import { makeStyles } from '@mui/styles';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import { Link } from 'react-router-dom';
import { Container, Grid } from '@mui/material';
import GridPaper from '../../util/GridPaper';

const useStyles = makeStyles(theme => ({
    form: {
        width: '100%', // Fix IE 11 issue.
        // marginTop: theme.spacing(1),
    },
    title: {
        paddingTop: '20px;'
    },
    submit: {
        // margin: theme.spacing(2, 0, 1),
    },
}));

export default function RltAvancado() {
    const classes = useStyles();

    return (
        <div>
            <Container >
                <Typography className={classes.title} variant="body1">
                    Avançado
                </Typography>
                <GridPaper container spacing={3} justifyContent='center'>
                    <Grid>
                        <Button
                            component={Link}
                            to={{
                                pathname: '/relatorio-frequencia-por-aluno-mes-ano-letivo',
                            }}
                            type="button"
                            fullWidth
                            variant="contained"
                            color="primary"
                            className={classes.submit}
                        >
                            Frequência por Aluno, Mês e Ano Letivo
                        </Button>
                    </Grid>

                </GridPaper>
            </Container>
        </div>
    );
}